import axios, { CancelToken } from 'axios';

import { TASKS_DEFINITIONS_COUNT } from 'RestAPIs/endpoints';

export type DefinitionCount = {
  count: number;
  definitionKey: string;
};

type Options = {
  params: {
    costCenterIds: string;
  };
  cancelToken: CancelToken;
};

export const getDefintionsCount = (options: Options) =>
  axios.get<DefinitionCount[]>(TASKS_DEFINITIONS_COUNT, { ...options });
